import { AxiosRequestConfig } from "axios";
import {
  CenterTacticalData,
  CenterStrategicData,
  GenerationType,
} from "../../../modules/operations/types";
import api from "../api-instance";

const ROUTE = "/Operations";

export interface CriticalFailure {
  usinaName: string;
  triggeredAt: string;
  clearedAt?: string;
  isActive: boolean;
  id: string;
  severity: number;
  code: string;
  name: string;
  message: string;
  rootDescription?: string;
  alarmKey: string;
  usinaCode: string;
  equipmentIdentifier: string;
  areaCode: string;
  fullAlarmSourceName: string;
  area: string;
  type: string;
  alarmDuration: string;
  usinaPhoneNumber: string;
}

export interface GetRecentCriticalFailuresParams {
  Type?: string;
  Area?: string;
  ClusterId?: string;
  UsinaId?: number;
}

export interface GetRecentCriticalFailuresResponse {
  criticalFailures: CriticalFailure[];
}

export async function getRecentCriticalFailures(
  params?: GetRecentCriticalFailuresParams,
): Promise<GetRecentCriticalFailuresResponse> {
  const config: AxiosRequestConfig = {
    params: params || {},
  };

  const result = await api.get(
    `${ROUTE}/Tactical/RecentCriticalFailures`,
    config,
  );
  return result.data;
}

export async function getCenterTactical(
  interval: string,
  clientId?: string,
  clusterId?: string,
  usinaId?: number,
  generationType?: GenerationType,
  startDate?: string,
  endDate?: string,
  weekStartDate?: string,
  month?: number,
  year?: number,
): Promise<CenterTacticalData> {
  const config: AxiosRequestConfig = {
    params: {
      interval,
      clientId,
      clusterId,
      usinaId,
      generationType,
      startDate,
      endDate,
      weekStartDate,
      month,
      year,
    },
  };

  const result = await api.get(`${ROUTE}/Tactical`, config);
  return result.data;
}

export async function getCenterStrategic(
  interval: string,
  clientId?: string,
  clusterId?: string,
  usinaId?: number,
  generationType?: GenerationType,
  startDate?: string,
  endDate?: string,
  weekStartDate?: string,
  month?: number,
  year?: number,
): Promise<CenterStrategicData> {
  const config: AxiosRequestConfig = {
    params: {
      interval,
      clientId,
      clusterId,
      usinaId,
      generationType,
      startDate,
      endDate,
      weekStartDate,
      month,
      year,
    },
  };

  const result = await api.get(`${ROUTE}/Strategic`, config);
  return result.data;
}

export interface ReprocessTacticalResponse {
  processedDates: string[];
  failedDates: string[];
}

export async function reprocessTactical(
  correctionDate: string,
  powerPlantIds?: string[],
): Promise<ReprocessTacticalResponse> {
  const result = await api.post(`${ROUTE}/Tactical/reprocess`, {
    correctionDate,
    powerPlantIds: powerPlantIds ?? null,
  });
  return result.data;
}
